exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "table {\n  width: 98%;\n  margin: 1%; }\n  table td, table th {\n    border: 1px solid black;\n    text-align: center;\n    padding: 3px; }\n    table td.selectable, table th.selectable {\n      cursor: pointer; }\n\n.selected {\n  background: rgba(243, 236, 37, 0.5); }\n\n.clear {\n  clear: both; }\n\n@media (max-width: 740px) {\n  .otherPrices div {\n    float: left;\n    width: 50% !important; } }\n@media (max-width: 440px) {\n  .otherPrices div {\n    float: left;\n    width: 100% !important; }\n\n  .priceTable {\n    width: 100%; }\n    .priceTable tr {\n      display: block;\n      float: left;\n      width: 15%; }\n    .priceTable th, .priceTable td {\n      display: block; } }\n.jump {\n  position: relative; }\n  .jump * {\n    position: absolute;\n    animation: jumping 1s infinite; }\n\n@keyframes jumping {\n  0% {\n    bottom: 0px; }\n  50% {\n    bottom: 8px; }\n  100% {\n    bottom: 0px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/order/order.component.css
// module id = 366
// module chunks = 2